import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-sale-orders',
  templateUrl: './sale-orders.component.html',
  styleUrls: ['./sale-orders.component.css']
})
export class SaleOrdersComponent implements OnInit {

  constructor(private orderService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  //getUrl='http://192.241.151.66:5000/viewSaleorder';
 //cancelUrl='http://192.241.151.66:5000/viewSaleorder/update/'
  output:any=[]
  OrderNumber=""
  cancelId=""

  //--------function for routing to order details-----
  getOrderDetails(Id:any){

    this.orderService.setOrderId(Id);
    this.router.navigateByUrl(('admin/order-detail')); 
    document.body.scrollTop = document.documentElement.scrollTop = 0; 

  }
  //---function for routing to create order
  NewOrder(){

    this.router.navigateByUrl(('admin/create-order')); 
  }
  //-------function for set order number of canceled-------
  DeleteOrder(Number:any,Id:any){

    this.OrderNumber=Number;
    this.cancelId=Id
  }
  //----function for cancel an order-------
  CancelOrder(){
    console.log("order number=",this.OrderNumber)
    //-------api cancel order-------------
     this.orderService.CancelOrder(this.cancelId).subscribe((res)=>{
      console.log("update =",res.sucess)

      this.ngOnInit();
    })
  }

  //-------date formating-------------
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe:any= null;
  DateFormat(value:any){

    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe
  }
  ngOnInit(): void {

    //-------api get()calling-------------
      this.orderService.OrderById("").subscribe((res)=>{
      this.output=res.data
      console.log("Invoice details =",this.output)
      })
  }

}
